import React from 'react';
import Radio from './Radio';
import styled from 'styled-components';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  options?: { value: string; label: string }[];
}

const RadioGroup = ({ value, onChange, options }: Props) => {
  return (
    <RadioGroupContainer>
      {options?.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          checkedValue={value}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </Radio>
      ))}
    </RadioGroupContainer>
  );
};

export default RadioGroup;

const RadioGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
